import { cn } from "@/lib/utils";
import { BaseEntryValue } from "./BaseEntryValue";
import type { BaseEntryValueProps } from "./BaseEntryValue";

export interface CheckboxEntryValueProps extends Omit<BaseEntryValueProps, "value"> {
    value: boolean | string | null;
}

export function CheckboxEntryValue({ value, inputLabel, size, ...props }: CheckboxEntryValueProps) {
    // Handle various formats the value might come in
    const isChecked = value === true || value === "true" || value === "Yes";

    return (
        <BaseEntryValue inputLabel={inputLabel} size={size} {...props}>
            <span
                className={cn(
                    "text-slate-900 dark:text-slate-200",
                    size === "sm" ? "text-sm" : size === "lg" ? "text-lg" : "text-base"
                )}
            >
                {isChecked ? "True" : "False"}
            </span>
        </BaseEntryValue>
    );
}
